module.exports = __webpack_public_path__ + "static/media/doclad5.58aa4a38.pdf";